var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#A445ED",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 27v21l21-10.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.a659db0104303a8b8ae071e0cf90119d.svg";
export { ForwardRef as ReactComponent };